


import RolePermissions from "../crud/rolePermissions";

import PDF from "../crud/pdf";
import Auth from "../auth";

import Users from "../users";
import Files from "../crud/files";
import ExportCsvTasks from "../crud/exportCsvTasks";
import RolesActionsPermissions from "../crud/rolesActionsPermissions";
import Roles from "../crud/roles";
import PublicCountries from "../crud/publicCountries";
import Currencies from "../crud/currencies";
import CurrencyRates from "../crud/currencyRates";
import Banks from "../crud/banks";
import Chains from "../crud/chains";
import CryptoTokens from "../crud/cryptoTokens";
import CryptoTopups from "../crud/cryptoTopups";
import CryptoWithdrawals from "../crud/cryptoWithdrawals";
import Messages from "../crud/messages";
import WalletUsers from "../crud/walletUsers";
import WalletUsersKyc from "../crud/walletUsersKyc";
import WalletPinCodes from "../crud/walletPinCodes";
import WalletNotifications from "../crud/walletNotifications";
import WalletAccounts from "../crud/walletAccounts";
import WalletWallets from "../crud/walletWallets";
import WalletTransfers from "../crud/walletTransfers";
import WalletEvents from "../crud/walletEvents";
import AccountingSystemAccounts from "../crud/accountingSystemAccounts";
import AccountingCryptoCollections from "../crud/accountingCryptoCollections";
import AccountingSystemTransactions from "../crud/accountingSystemTransactions";
import AccountingExpensesTransactions from "../crud/accountingExpensesTransactions";
import AccountingRevenueTransactions from "../crud/accountingRevenueTransactions";
import PartnersReferralCodes from "../crud/partnersReferralCodes";
import PartnersReferrals from "../crud/partnersReferrals";
import PartnersRewards from "../crud/partnersRewards";
import PartnersPayouts from "../crud/partnersPayouts";

const ServerConfig = {
    auth: Auth,
    users: Users,
    rolePermissions: RolePermissions,
    PDF: PDF,
    files: Files,
    roles: Roles,
    rolesActionsPermissions: RolesActionsPermissions,
    exportCsvTasks: ExportCsvTasks,
    publicCountries: PublicCountries,
    currencies: Currencies,
    currencyRates: CurrencyRates,
    banks: Banks,
    chains: Chains,
    cryptoTokens: CryptoTokens,
    cryptoTopups: CryptoTopups,
    cryptoWithdrawals: CryptoWithdrawals,
    messages: Messages,
    walletUsers: WalletUsers,
    walletUsersKyc: WalletUsersKyc,
    walletPinCodes: WalletPinCodes,
    walletNotifications: WalletNotifications,
    walletAccounts: WalletAccounts,
    walletWallets: WalletWallets,
    walletTransfers: WalletTransfers,
    walletEvents: WalletEvents,
    accountingSystemAccounts: AccountingSystemAccounts,
    accountingCryptoCollections: AccountingCryptoCollections,
    accountingSystemTransactions: AccountingSystemTransactions,
    accountingExpensesTransactions: AccountingExpensesTransactions,
    accountingRevenueTransactions: AccountingRevenueTransactions,
    partnersReferralCodes: PartnersReferralCodes,
    partnersReferrals: PartnersReferrals,
    partnersRewards: PartnersRewards,
    partnersPayouts: PartnersPayouts
};

export class ServerBuilder {
    #serverData = {};

    constructor(serverData) {
        this.#serverData = serverData;
    }

    build() {
        const server = {};
        Object.entries(ServerConfig).forEach(([key, Server]) => {
            server[key] = new Server(this.#serverData);
        });
        return server;
    }
}

